import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import {
  clearCreatives,
  fetchChannelsAndCreative,
  fetchCreatives,
  reset,
} from 'features/creative/add/creativeAddSlice'
import SelectChannel from 'features/creative/add/SelectChannel'
import BuildCreative from 'features/creative/add/build/BuildCreative'
import CreativeImport from 'features/creative/add/import/CreativeImport'
import { reset as resetImport } from 'features/creative/add/import/creativeImportSlice'
import {
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from 'react-router-dom'
import { isNullOrUndefined } from 'utils'
import { isNil } from 'lodash'

const CreativeAdd = ({ readOnly = false }) => {
  const dispatch = useDispatch()
  const { path } = useRouteMatch()
  const history = useHistory()
  const { creativeId, accountId } = useParams()
  const { bizChannelType, selectedChannel, importedId } = useSelector(
    state => state.creative.creativeAdd
  )

  const imported =
    !isNullOrUndefined(creativeId) || !isNullOrUndefined(importedId)

  useEffect(
    () => () => {
      batch(() => {
        dispatch(reset())
        dispatch(resetImport())
      })
    },
    [dispatch]
  )
  useEffect(() => {
    dispatch(fetchChannelsAndCreative(creativeId))
  }, [dispatch, creativeId])
  useEffect(() => {
    if (isNil(selectedChannel)) {
      dispatch(clearCreatives())
    } else {
      dispatch(fetchCreatives())
    }
  }, [dispatch, selectedChannel])

  return (
    <div className="wrap_material">
      <SelectChannel readOnly={readOnly || !!creativeId} />
      <Switch>
        <Route path={`${path}/import`}>
          <CreativeImport readOnly={readOnly} />
        </Route>
        <Route path={path}>
          <BuildCreative
            bizChannelType={bizChannelType}
            afterSave={() => history.push(`/${accountId}/creatives`)}
            onClickOtherTab={
              creativeId
                ? null
                : () => history.push(`/${accountId}/creatives/add/import`)
            }
            readOnly={readOnly}
            imported={imported}
          />
        </Route>
      </Switch>
    </div>
  )
}

export default CreativeAdd

CreativeAdd.propTypes = {
  channelId: PropTypes.string,
  readOnly: PropTypes.bool,
}
